import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { IRows } from "../../../Components/Filter/WSFilterComponent";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";


export const CategoryManagementList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  
  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  // Header
   useEffect(() => {
  updateMainHeader("Inventory");
  labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
}, []);


  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Unit Management": "/unit/list" },
  ]);

  const source = {
    url: "categories/list",  // ✅ Fixed API path
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const 
  };


 
  const columns: IColumns[] = [
   
    { header: "Category Name", fieldName: "CategoryName" },
    { header: "Description", fieldName: "Description", tooltip: true },
     {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        const categoryId = row.CategoryId ;
        if (!categoryId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid warehouse data - missing ID", "error");
          return;
        }
        
        if (action === "Edit") {
          navigate(`/category/${categoryId}`);
        } else if (action === "Delete") {
          setSelectedId(categoryId);
          setPopupOpen(true);
        }
      },
    },
  ];

  // Filters (UI only)
  const filterRows: IRows[] = [
    {
      label: "Item Name",
      fieldName: "itemname",
      type: "text",
      operator: "like",
      rowDivision: 6,
    },
    {
      label: "Category",
      fieldName: "category",
      type: "text",
      operator: "like",
      rowDivision: 6,
    },
    {
      label: "Supplier Name",
      fieldName: "suppliername",
      type: "text",
      operator: "like",
      rowDivision: 6,
    },
    {
      label: "Created Date",
      fieldName: "createdAt",
      type: "date",
      operator: "gte",
      rowDivision: 6,
    },
  ];

  const handleClick = () => {
    navigate("/category");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="categoryGrid"
            title="Category Management"
            headerType="modern"
            columns={columns}
            source={source}
            exportCsv
            rowsPerPageCount={10}
            searchBox={{ searchMode: "query" }}
            addButton={{ label: "Add New Category", color: "secondary" }}
            onAddButtonClick={handleClick}
            
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>
      <ConfirmationPopup
          type="DELETE"
          apiUrl="categories"  
          id={selectedId}
          confirmMessage="Are you sure you want to delete this category?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("categoryGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.detail, "error");
            }
          }}
        />
    </Grid>
  );
};